module.exports = __webpack_public_path__ + "static/img/heart.ef01193.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/icon-set/heart.svg
// module id = LOeA
// module chunks = 1